import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const FIL_ROUGE_WEEKDAYS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export const filRougeRhythm = (task) => task.fil_rouge_frequency === 'weekly'
    ? `Chaque ${(FIL_ROUGE_WEEKDAYS[task.fil_rouge_weekday] || 'semaine').toLowerCase()}`
    : 'Quotidien';

export const FilRougeFrequencyFields = ({ frequency = 'daily', weekday = 0, onFrequencyChange, onWeekdayChange }) => (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-testid="fil-rouge-frequency-fields">
        <div className="min-w-0 space-y-1">
            <Label htmlFor="fil-rouge-frequency" className="text-xs">Fréquence des relances</Label>
            <Select value={frequency} onValueChange={onFrequencyChange}>
                <SelectTrigger id="fil-rouge-frequency" data-testid="fil-rouge-frequency"><SelectValue /></SelectTrigger>
                <SelectContent data-testid="fil-rouge-frequency-options">
                    <SelectItem value="daily" data-testid="fil-rouge-frequency-daily">Journalière</SelectItem>
                    <SelectItem value="weekly" data-testid="fil-rouge-frequency-weekly">Hebdomadaire</SelectItem>
                </SelectContent>
            </Select>
        </div>
        {frequency === 'weekly' && (
            <div className="min-w-0 space-y-1">
                <Label htmlFor="fil-rouge-weekday" className="text-xs">Jour de relance</Label>
                <Select value={String(weekday)} onValueChange={(value) => onWeekdayChange(Number(value))}>
                    <SelectTrigger id="fil-rouge-weekday" data-testid="fil-rouge-weekday"><SelectValue /></SelectTrigger>
                    <SelectContent data-testid="fil-rouge-weekday-options">
                        {FIL_ROUGE_WEEKDAYS.map((day, index) => (
                            <SelectItem key={day} value={String(index)} data-testid={`fil-rouge-weekday-${index}`}>{day}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
        )}
    </div>
);